export default __webpack_public_path__ + "static/media/KHInterference-Regular.bc74ec1e.otf";